import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from "react";
import { useJobContext } from "../hooks/Jobs";
import { diccionarioTipoEstructuraCrearProyectoSufijoMSJServidor } from "../utils/parseStringTipoEstructura";
// import dataProyect from './dataProyect';
import { dataProyect } from "../config/enums/enums";
import { iProyectoABP, iProyectoUA } from "../interfaces/Proyecto/iProyecto";
import { useActividadesContext } from "../components/UmmIACategories/Hook/useActividades";

// Contexto para el objeto de proyecto

interface ProyectContextProps {
  proyecto: iProyectoUA | iProyectoABP;
  enviarProyecto: (userChoiceStageObjProject: number) => void;
  setProyecto: React.Dispatch<React.SetStateAction<iProyectoUA | iProyectoABP>>;
  enviarPropuestaInicialUsuario: (
    proyecto: iProyectoUA | iProyectoABP,
    msg: string
  ) => void;
}

const ProyectoContext = createContext<ProyectContextProps>(
  {} as ProyectContextProps
);

const initialState = dataProyect["aprendizaje_basado_en_proyectos"];

interface Props {
  children: React.ReactNode;
}

export const ProyectoProvider: FC<Props> = ({ children }) => {
  const { etapa, handleStartJob, tipoEstructura, in_tokens, out_tokens, costo } = useJobContext();
  const [proyecto, setProyecto] = useState(initialState);
  const { selectedApp } = useActividadesContext();
  const ummiappId = selectedApp?.id_componente || "";
  const ummiappName = selectedApp?.nombre || "";

  useEffect(() => {
    if (tipoEstructura) {
        const base = dataProyect[tipoEstructura];
        setProyecto({
        ...base,
        ummiappId,
        ummiappName,
      });
    }
  }, [tipoEstructura, ummiappId, ummiappName]);

  /**
   * Esta función permite manejar las mutaciones de los stage y mantener el state de los proyectos
   * @param {*} userChoiceStageObjProject
   */
  const enviarProyecto = (userChoiceStageObjProject: number) => {
    console.log("proyecto", proyecto);

    //Construimos un objeto con los valores actualizados, no puedo usar el state "proyecto" actualizado ya que no alcanza el trigger y no hay un callback
    const objProjectUpgrade = actualizarProyecto(
      proyecto,
      userChoiceStageObjProject
    );

    //Actualizamos el state con la seleccion del usuario en el stage correspondiente
    setProyecto((prevProyecto) =>
      actualizarProyecto(prevProyecto, userChoiceStageObjProject)
    );

    console.log("enviarProyecto objProjectUpgrade", objProjectUpgrade);

    //Enviamos los parametros para iniciar el job
    handleStartJob(
      objProjectUpgrade,
      etapa + 1,
      diccionarioTipoEstructuraCrearProyectoSufijoMSJServidor(tipoEstructura)
    );
  };

  const enviarPropuestaInicialUsuario = (
    proyecto: iProyectoUA | iProyectoABP,
    msg: string
  ) => {
    const etapaInicial = 0;
    console.log("enviarPropuestaInicialUsuario!!!", msg);
    setProyecto(proyecto);
    handleStartJob(proyecto, etapaInicial, msg);
  };

  const actualizarProyecto = (
  prevProyecto: iProyectoUA | iProyectoABP,
  userChoiceStageObjProject: any
): iProyectoUA | iProyectoABP => {
  const keyEtapa = `user_choice_stage_${etapa}`;

  return {
    ...prevProyecto,
    [keyEtapa]: userChoiceStageObjProject,
    ...(in_tokens !== undefined && { in_tokens }),
    ...(out_tokens !== undefined && { out_tokens })
  };
};

  useEffect(() => {
    console.log(proyecto);
  }, [proyecto]);

  return (
    <ProyectoContext.Provider
      value={{
        proyecto,
        enviarProyecto,
        setProyecto,
        enviarPropuestaInicialUsuario,
      }}
    >
      {children}
    </ProyectoContext.Provider>
  );
};

export const useProyecto = () => {
  return useContext(ProyectoContext);
};
